import { ReactNode, useState } from "react";
import { useGeneralHooks } from "../../../../Hooks/hooks"
import { IUserDrawerList } from "../../../../Interfaces/componentTypes"
import useDialogHooks from "../../../Dialog/dialog-hooks";
import UserDataDialog from "../../../Dialog/DialogContents/UserProfile/UserData/userDataDialog";
import SettingsDialog from "../../../Dialog/DialogContents/UserProfile/Settings/settingsDialog";
import ChangePasswordDialog from "../../../Dialog/DialogContents/UserProfile/ChangPassword/changePasswordDialog";
import { IGetMe } from "../../../../Interfaces/responseTypes";
import { SecureIcon, Settings, UserDataIcon } from "../../../../Assets/Icons";
import LogOutDialog from "../../../Dialog/DialogContents/UserProfile/LogOut/logOutDialog";

const useUserDrawerHooks = () => {
    const { currentUser,t } = useGeneralHooks();
    const { open, onOpen, onClose } = useDialogHooks();
    const [dialogComponent, setDialogComponent] = useState<ReactNode>(<></>)
    const userDrawerItems: IUserDrawerList = [
        {
            title: t('Home.User_Drawer.Data'),
            icon: UserDataIcon,
            onClick: () => {
                onOpen();
                setDialogComponent(<UserDataDialog user={(currentUser as IGetMe)} onClose={onClose} />)
            }
        },
        {
            title: t('Home.User_Drawer.Settings'),
            icon: Settings,
            onClick: () => {
                onOpen();
                setDialogComponent(<SettingsDialog onClose={onClose} />)
            }
        },
        {
            title: t('Home.User_Drawer.Security'),
            icon: SecureIcon,
            onClick: () => {
                onOpen();
                setDialogComponent(<ChangePasswordDialog onClose={onClose} />)
            }
        },
    ];

    const onOpenLogOutDialog = () => {
        onOpen();
        setDialogComponent(<LogOutDialog onClose={onClose} />)
    }

    return {
        onClose,
        onOpenLogOutDialog,
        open,
        userDrawerItems,
        dialogComponent
    }
};

export default useUserDrawerHooks